module.exports = __webpack_public_path__ + "static/media/logo-마인즈랩@3x.1f2f8edf.png";